import React from 'react';
import { WifiOffIcon } from 'base/components/Icon';
import RowActionButton from 'base/components/table/RowActionButton';
import theme from '../../theme';
import CacheOfflineToggle from '../containers/CacheOfflineToggle';

const getCacheOfflineColumn = (onClick) => ({
  Header: <WifiOffIcon color={theme.colors.medium} />,
  Cell: ({original}) => { // eslint-disable-line

    if (original.entityType === 'document' && original.file
        && (original.file.mime === 'application/pdf' || original.file.pdfCopyFilename)) {
      return (
        <RowActionButton
          original={original}
          handleClick={onClick}
        >
          <CacheOfflineToggle document={original} color={theme.colors.medium} />
        </RowActionButton>
      );
    }

    return <></>;
  },
  sortable: false,
  width: 50,
});

export default getCacheOfflineColumn;
